<template lang="pug">
  v-form(autocomplete='false' v-model='formulario_validado')
    v-row
      v-col
        v-radio-group(label='Comprobante' v-model='Datos.tipo_de_documento_comprobante'  )
          template(v-for='item in tipo_de_nota_de_credito_a_imprimir' )
            v-radio( :label='item.label' :value='item.value' )
       
    v-row(v-if='Datos.tipo_de_documento_comprobante == 3')
      v-col
        v-autocomplete(:rules='[Rules.required]' label='Tipo de nota de crédito' v-model='Datos.tipo_de_nota_de_credito' :items='tipo_de_nota_de_credito' item-text='label' item-value='value')
    
    v-row(v-if='Datos.tipo_de_documento_comprobante == 4')
      v-col
        v-autocomplete(:rules='[Rules.required]' label='Tipo de nota de débito' v-model='Datos.tipo_de_nota_de_debito' :items='tipo_de_nota_de_debito' item-text='label' item-value='value')
    v-row
      v-col
        v-menu(v-model='creationDateDialog' :close-on-content-click='true' :nudge-right='40' transition='scale-transition' offset-y min-width='290px' )
          template(v-slot:activator='{ on }')
            v-text-field(v-model='Datos.fecha_de_emision' label='Fecha de emisión' readonly v-on='on' :disabled='Datos.isAnnulled || Datos.isClose')
          v-date-picker(:rules='[Rules.required]' v-model='Datos.fecha_de_emision' @input='datePicker = false' )
      v-col
        v-menu( v-model='expirationDateDialog' :close-on-content-click='true' :nudge-right='40' transition='scale-transition' offset-y min-width='290px' )
          template(v-slot:activator='{ on }')
            v-text-field(v-model='Datos.fecha_de_vencimiento' label='Fecha de vencimiento' readonly v-on='on' :disabled='Datos.isAnnulled || Datos.isClose')
          v-date-picker( v-model='Datos.fecha_de_vencimiento' @input='datePicker = false' )
        
    v-row(v-if='Datos.tipo_de_documento_comprobante == 1 || Datos.tipo_de_documento_comprobante == 2')
      v-col
        v-autocomplete(:rules='[Rules.required]' label='Medio de pago' v-model='Datos.medio_de_pago' :items='paymentMethods' item-text='description' item-value='description')
      v-col  
        minicrudCombobox( @resultado="val => Datos.condiciones_de_pago = val" item-value='descripcion' arreglo='Condiciones de pago')
    v-row(v-if='Datos.tipo_de_documento_comprobante == 1 || Datos.tipo_de_documento_comprobante == 2')
      v-col
        v-autocomplete(:rules='[Rules.required]' label='Moneda' v-model='Datos.moneda' :items='tipo_monedas'  item-text='label' item-value='value' )
    v-row(v-if='Datos.tipo_de_documento_comprobante == 1 || Datos.tipo_de_documento_comprobante == 2')
      v-col
        v-text-field( label='Orden de compra' v-model='Datos.orden_compra_servicio')
        v-textarea( value='Observaciones' label='Observaciones' v-model='Datos.observaciones' )

</template>
<script>
  import {mapGetters, mapState, mapActions} from 'vuex'
  import tipo_de_nota_de_credito from '@/jsons/tipo_de_nota_de_credito.json'
  import tipo_de_nota_de_debito from '@/jsons/tipo_de_nota_de_debito.json'
  import tipo_de_documento_comprobante from '@/jsons/tipo_de_documento_comprobante.json'
  import tipo_monedas from '@/jsons/tipo_monedas.json'

  export default {
    data:()=>({
      creationDateDialog: false,
      expirationDateDialog: false,
      formulario_validado: false,
      tipo_de_documento_comprobante,
      tipo_de_nota_de_credito,
      tipo_de_nota_de_debito,
      tipo_monedas

    }),
    props:{
      modelo: String
    },
    
    watch: {
      'Datos.tipo_de_documento_comprobante'(){
        switch(this.Datos.tipo_de_documento_comprobante){
          case 1:
            this.Datos.nombre_de_documento_comprobante = "Factura"
            this.Datos.serie_comprobante = "F001"
            this.Datos.operacion = 'generar_comprobante'
            this.sunat_transaction = 1
            break
          case 2: 
            this.Datos.nombre_de_documento_comprobante = "Boleta"
            this.Datos.serie_comprobante = "B001"
            this.Datos.operacion = 'generar_comprobante'
            this.sunat_transaction = 1
            break
          case 3: 
            this.Datos.nombre_de_documento_comprobante_reversion = "Nota de crédito"
            this.Datos.serie_comprobante_reversion = this.Datos.documento_que_se_modifica_serie
            this.Datos.operacion = 'generar_comprobante'
            this.sunat_transaction = 1
            break
          case 4: 
            this.Datos.nombre_de_documento_comprobante_reversion = "Nota de débito"
            this.Datos.serie_comprobante_reversion = this.Datos.documento_que_se_modifica_serie
            this.Datos.operacion = 'generar_comprobante'
            this.sunat_transaction = 1
            break
        }
      },
   
    },
    computed:{
      tipo_de_nota_de_credito_a_imprimir: function(){
       /* if(!this.Datos.vinculo_comprobante){
          return this.tipo_de_documento_comprobante.filter(item=>item.value == 1 || item.value == 2)
        } else if(!this.Datos.vinculo_comprobante_reversion) {
          return this.tipo_de_documento_comprobante.filter(item=>item.value == 3 || item.value == 4)
        } else if(this.Datos.vinculo_comprobante_reversion) {
          return []
        }*/
        return this.tipo_de_documento_comprobante
       
      },
      ...mapState({
        Datos: state => state.Outputs.data,
        Rules: state => state.Helpers.rules,
      }),
      
      ...mapGetters({
        paymentMethods: 'PaymentMethods/record',
      })
    },
    components: {
      minicrudCombobox : ()=>import('@/components/minicrud_combobox')
    }
 
    
  }
</script>

